module.exports = __webpack_public_path__ + "static/media/ines_ferreira.4239948f.jpg";